var R;!function(R){R.INTERNAL_ERROR="INTERNAL_ERROR"}(R||(R={}));export{R as ExternalAppErrorCode};
